module.exports = __webpack_public_path__ + "front/img/sub-img-1.3c4ae606.png";